// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/cloud_components.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { CloudComponentsService } from "./cloud_components_pb";

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateCloudComponentVpc
 */
export const createCloudComponentVpc = CloudComponentsService.method.createCloudComponentVpc;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.UpdateCloudComponentVpc
 */
export const updateCloudComponentVpc = CloudComponentsService.method.updateCloudComponentVpc;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetCloudComponentVpc
 */
export const getCloudComponentVpc = CloudComponentsService.method.getCloudComponentVpc;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListCloudComponentVpc
 */
export const listCloudComponentVpc = CloudComponentsService.method.listCloudComponentVpc;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteCloudComponentVpc
 */
export const deleteCloudComponentVpc = CloudComponentsService.method.deleteCloudComponentVpc;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateCloudComponentCluster
 */
export const createCloudComponentCluster = CloudComponentsService.method.createCloudComponentCluster;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateRecoverClusterTarget
 */
export const createRecoverClusterTarget = CloudComponentsService.method.createRecoverClusterTarget;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListRecoveryClusterTargets
 */
export const listRecoveryClusterTargets = CloudComponentsService.method.listRecoveryClusterTargets;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ActivateRecoveryClusterTarget
 */
export const activateRecoveryClusterTarget = CloudComponentsService.method.activateRecoveryClusterTarget;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeactivateRecoveryClusterTarget
 */
export const deactivateRecoveryClusterTarget = CloudComponentsService.method.deactivateRecoveryClusterTarget;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.UpdateCloudComponentCluster
 */
export const updateCloudComponentCluster = CloudComponentsService.method.updateCloudComponentCluster;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetCloudComponentCluster
 */
export const getCloudComponentCluster = CloudComponentsService.method.getCloudComponentCluster;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListCloudComponentCluster
 */
export const listCloudComponentCluster = CloudComponentsService.method.listCloudComponentCluster;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListServerlessClusters
 */
export const listServerlessClusters = CloudComponentsService.method.listServerlessClusters;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteCloudComponentCluster
 */
export const deleteCloudComponentCluster = CloudComponentsService.method.deleteCloudComponentCluster;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.TestClusterConnection
 */
export const testClusterConnection = CloudComponentsService.method.testClusterConnection;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateCloudComponentStorage
 */
export const createCloudComponentStorage = CloudComponentsService.method.createCloudComponentStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetCloudComponentStorage
 */
export const getCloudComponentStorage = CloudComponentsService.method.getCloudComponentStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListCloudComponentStorage
 */
export const listCloudComponentStorage = CloudComponentsService.method.listCloudComponentStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.UpdateCloudComponentStorage
 */
export const updateCloudComponentStorage = CloudComponentsService.method.updateCloudComponentStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteCloudComponentStorage
 */
export const deleteCloudComponentStorage = CloudComponentsService.method.deleteCloudComponentStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingEnvironmentCloudStorage
 */
export const createBindingEnvironmentCloudStorage = CloudComponentsService.method.createBindingEnvironmentCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingEnvironmentCloudStorage
 */
export const getBindingEnvironmentCloudStorage = CloudComponentsService.method.getBindingEnvironmentCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingEnvironmentCloudStorage
 */
export const listBindingEnvironmentCloudStorage = CloudComponentsService.method.listBindingEnvironmentCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingEnvironmentCloudStorage
 */
export const deleteBindingEnvironmentCloudStorage = CloudComponentsService.method.deleteBindingEnvironmentCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingClusterCloudStorage
 */
export const createBindingClusterCloudStorage = CloudComponentsService.method.createBindingClusterCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingClusterCloudStorage
 */
export const getBindingClusterCloudStorage = CloudComponentsService.method.getBindingClusterCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingClusterCloudStorage
 */
export const listBindingClusterCloudStorage = CloudComponentsService.method.listBindingClusterCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingClusterCloudStorage
 */
export const deleteBindingClusterCloudStorage = CloudComponentsService.method.deleteBindingClusterCloudStorage;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateCloudComponentContainerRegistry
 */
export const createCloudComponentContainerRegistry = CloudComponentsService.method.createCloudComponentContainerRegistry;

/**
 * Deprecated: container registries are immutable metadata records. Create a new
 * registry and delete the old one instead of updating in place.
 *
 * @generated from rpc chalk.server.v1.CloudComponentsService.UpdateCloudComponentContainerRegistry
 * @deprecated
 */
export const updateCloudComponentContainerRegistry = CloudComponentsService.method.updateCloudComponentContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetCloudComponentContainerRegistry
 */
export const getCloudComponentContainerRegistry = CloudComponentsService.method.getCloudComponentContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListCloudComponentContainerRegistry
 */
export const listCloudComponentContainerRegistry = CloudComponentsService.method.listCloudComponentContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteCloudComponentContainerRegistry
 */
export const deleteCloudComponentContainerRegistry = CloudComponentsService.method.deleteCloudComponentContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingClusterContainerRegistry
 */
export const createBindingClusterContainerRegistry = CloudComponentsService.method.createBindingClusterContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingClusterContainerRegistry
 */
export const getBindingClusterContainerRegistry = CloudComponentsService.method.getBindingClusterContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingClusterContainerRegistry
 */
export const listBindingClusterContainerRegistry = CloudComponentsService.method.listBindingClusterContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingClusterContainerRegistry
 */
export const deleteBindingClusterContainerRegistry = CloudComponentsService.method.deleteBindingClusterContainerRegistry;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingClusterGateway
 */
export const createBindingClusterGateway = CloudComponentsService.method.createBindingClusterGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingClusterGateway
 */
export const getBindingClusterGateway = CloudComponentsService.method.getBindingClusterGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingClusterGateway
 */
export const listBindingClusterGateway = CloudComponentsService.method.listBindingClusterGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingClusterGateway
 */
export const deleteBindingClusterGateway = CloudComponentsService.method.deleteBindingClusterGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingServicesGateway
 */
export const createBindingServicesGateway = CloudComponentsService.method.createBindingServicesGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingServicesGateway
 */
export const getBindingServicesGateway = CloudComponentsService.method.getBindingServicesGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingServicesGateway
 */
export const listBindingServicesGateway = CloudComponentsService.method.listBindingServicesGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingServicesGateway
 */
export const deleteBindingServicesGateway = CloudComponentsService.method.deleteBindingServicesGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingPrivateGateway
 */
export const createBindingPrivateGateway = CloudComponentsService.method.createBindingPrivateGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingPrivateGateway
 */
export const getBindingPrivateGateway = CloudComponentsService.method.getBindingPrivateGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingPrivateGateway
 */
export const listBindingPrivateGateway = CloudComponentsService.method.listBindingPrivateGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingPrivateGateway
 */
export const deleteBindingPrivateGateway = CloudComponentsService.method.deleteBindingPrivateGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingClusterBackgroundPersistenceDeployment
 */
export const createBindingClusterBackgroundPersistenceDeployment = CloudComponentsService.method.createBindingClusterBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingClusterBackgroundPersistenceDeployment
 */
export const getBindingClusterBackgroundPersistenceDeployment = CloudComponentsService.method.getBindingClusterBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingClusterBackgroundPersistenceDeployment
 */
export const listBindingClusterBackgroundPersistenceDeployment = CloudComponentsService.method.listBindingClusterBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingClusterBackgroundPersistenceDeployment
 */
export const deleteBindingClusterBackgroundPersistenceDeployment = CloudComponentsService.method.deleteBindingClusterBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingClusterTelemetryDeployment
 */
export const createBindingClusterTelemetryDeployment = CloudComponentsService.method.createBindingClusterTelemetryDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingClusterTelemetryDeployment
 */
export const getBindingClusterTelemetryDeployment = CloudComponentsService.method.getBindingClusterTelemetryDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingClusterTelemetryDeployment
 */
export const listBindingClusterTelemetryDeployment = CloudComponentsService.method.listBindingClusterTelemetryDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingClusterTelemetryDeployment
 */
export const deleteBindingClusterTelemetryDeployment = CloudComponentsService.method.deleteBindingClusterTelemetryDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingEnvironmentGateway
 */
export const createBindingEnvironmentGateway = CloudComponentsService.method.createBindingEnvironmentGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingEnvironmentGateway
 */
export const getBindingEnvironmentGateway = CloudComponentsService.method.getBindingEnvironmentGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingEnvironmentGateway
 */
export const listBindingEnvironmentGateway = CloudComponentsService.method.listBindingEnvironmentGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingEnvironmentGateway
 */
export const deleteBindingEnvironmentGateway = CloudComponentsService.method.deleteBindingEnvironmentGateway;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.CreateBindingEnvironmentBackgroundPersistenceDeployment
 */
export const createBindingEnvironmentBackgroundPersistenceDeployment = CloudComponentsService.method.createBindingEnvironmentBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.GetBindingEnvironmentBackgroundPersistenceDeployment
 */
export const getBindingEnvironmentBackgroundPersistenceDeployment = CloudComponentsService.method.getBindingEnvironmentBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.ListBindingEnvironmentBackgroundPersistenceDeployment
 */
export const listBindingEnvironmentBackgroundPersistenceDeployment = CloudComponentsService.method.listBindingEnvironmentBackgroundPersistenceDeployment;

/**
 * @generated from rpc chalk.server.v1.CloudComponentsService.DeleteBindingEnvironmentBackgroundPersistenceDeployment
 */
export const deleteBindingEnvironmentBackgroundPersistenceDeployment = CloudComponentsService.method.deleteBindingEnvironmentBackgroundPersistenceDeployment;
